import $ from 'jquery';
import {
  $Doc,
  $Win
} from "../utils/jQueryGlobals";
import { gsapSingleton, scrollTriggerSingleton } from "../gsap";
const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();

gsap.registerPlugin(ScrollTrigger);

$Win.on('scroll', () => {
	const isMobile = window.innerWidth <= 1024;
	const scrollLimit = isMobile ? 20 : 190;
	if ($Doc.scrollTop() > scrollLimit) {
		$('header').addClass('no-top');
	} else {
		$('header').removeClass('no-top');
	}
});



// let hamburgher = $('.hamburger');

// $(hamburgher).on('click', function () {
//   if ($(this).hasClass('is-active')) {
//     $(this).removeClass('is-active');
//     $('#menu-items').hide();
//     $('html, body').removeClass('open-menu no-scroll');
//   } else {
//     $(this).addClass('is-active');
//     $('#menu-items').show();
//     $('html, body').addClass('open-menu no-scroll');

//     let titoliHeader = document.querySelectorAll('.menu-item > a');
//     console.log(titoliHeader[0]);
    


//     titoliHeader.forEach(element => {
//       gsap.from(element, {
//         y: '110%',
//         delay: 0.3,
//         opacity: 0,
//         stagger: { each: 0.1 },
//       });
//     });

//   }
// })



const $header = $('header'); 
const $menuContainer = $('.menu-items > .menu-item');
if (window.innerWidth > 1024) {
  $menuContainer.on('mouseenter', function() {
    $header.addClass('hover-menu');
    $(this).addClass('hover-sub-menu');
    console.log('enter');
    
  
    const $subMenu = $(this).find('.sub-menu');
    if ($subMenu.length === 0) return;
  
    let calculatedHeight = 0;
    $subMenu.children('.menu-item').each(function() {
      calculatedHeight += $(this).outerHeight(true);
    });
    const verticalPadding = 30; 
    const targetHeight = calculatedHeight + verticalPadding;
  
    gsap.to($subMenu, {
      height: targetHeight,
      backgroundColor: '#ffffff',
      duration: 0.5,
    });
  
  });
  
  $menuContainer.on('mouseleave', function() {
    console.log('leave');
    $header.removeClass('hover-menu');
    $(this).removeClass('hover-sub-menu');
  
    const $subMenu = $(this).find('.sub-menu');
    gsap.killTweensOf($subMenu);
      gsap.to($subMenu, {
      height: 0,
      backgroundColor: 'transparent',
      duration: 0.3,
    });
  });
}else {

  let hamburgher = $('.hamburger');
  let menuIcon = $('.menu-item-has-children .icon');
  console.log(menuIcon[0]);
  

  $(hamburgher).on('click', function () {
    const $this = $(this); // Salva il riferimento all'elemento cliccato
    const $menuItems = $('#menu-items');
    const $htmlBody = $('html, body');

    if ($this.hasClass('is-active')) {
      $this.removeClass('is-active');
      $menuItems.hide();
      $htmlBody.removeClass('open-menu no-scroll');
    } else {
      $this.addClass('is-active');
      $menuItems.show();
      $htmlBody.addClass('open-menu no-scroll');
      let titoliHeader = document.querySelectorAll('.menu-item');


      titoliHeader.forEach(element => {
        gsap.from(element, {
          y: '110%',
          delay: 0.3,
          opacity: 0,
          stagger: {
            each: 0.1
          },
        });
      });
    }
  });


  $(menuIcon).on('click', function () {
    const $this = $(this); 
    const $submenu = $this.siblings('ul.sub-menu');

  
    if ($submenu.hasClass('is-active')) {
      $(this).removeClass('is-active');
      $submenu.removeClass('is-active');
    } else {
      $(this).addClass('is-active');
      $submenu.addClass('is-active');
    }
  });		
}
